import { connect } from 'react-redux';
import { setColor } from '../../actions/canvas';
import Color from './color';
import Const from '../../config/const';

const mapStateToProps = ({ canvas }) => ({
  ...canvas,
  defaultColor: Const.defaultColor
});

export default connect(mapStateToProps, {
  setColor
})(Color);
